import Button from '@atoms/Button/Button';
import Cta from '@atoms/Cta/Cta';
import Text from '@atoms/Text/Text';
import { ILink } from '@models/ILink';
import SiteEnum from '@models/enums/SiteEnum';
import VariantTypeEnum from '@models/enums/VariantTypeEnum';
import classNames from 'classnames';

export interface IHeadlineAndTextBlock {
  readonly heading?: string;
  readonly subText?: string;
  readonly ctaStyle?: Exclude<VariantTypeEnum, VariantTypeEnum.Secondary>;
  readonly link?: ILink;
  readonly site: SiteEnum;
}

const HeadlineAndTextBlock = ({
  heading,
  subText = '',
  ctaStyle = VariantTypeEnum.Primary,
  link,
  site,
}: IHeadlineAndTextBlock) => {
  const LinkElement = () => {
    if (link) {
      return ctaStyle === VariantTypeEnum.Primary ? (
        <Button
          site={site}
          as="link"
          label={link?.text}
          href={link?.url}
          target={link?.target}
        />
      ) : (
        <Cta
          site={site}
          linkIcon={link?.linkIcon}
          text={link?.text}
          url={link?.url}
          target={link?.target}
        />
      );
    }
  };

  return (
    <section className="tw-grid-container tw-gap-y-md tw-text-black md:tw-gap-y-lg">
      {heading && (
        <Text
          variant="headline"
          className={classNames(
            'tw-col-span-4',
            subText
              ? 'md:tw-col-span-3 lg:tw-col-span-5'
              : 'md:tw-col-span-full lg:tw-col-span-8'
          )}
        >
          {heading}
        </Text>
      )}
      {subText && (
        <div
          className={classNames(
            heading
              ? 'tw-col-span-4 md:tw-col-span-3 md:tw-col-start-4 lg:tw-col-span-6 lg:tw-col-start-7'
              : 'tw-col-span-full xl:tw-col-span-6',
            'tw-flex tw-flex-col tw-items-start tw-gap-y-md md:tw-gap-y-lg'
          )}
        >
          <div
            className="tw-rich-text"
            dangerouslySetInnerHTML={{ __html: subText }}
          />
          {link && <LinkElement />}
        </div>
      )}
      {link && (
        <div className="tw-col-start-1">
          {link && !subText && <LinkElement />}
        </div>
      )}
    </section>
  );
};

export default HeadlineAndTextBlock;
